module.exports = __webpack_public_path__ + "1_0_61/img/mute.10ae1a00.svg";